import IconClose from "./close.svg?react";
import "./index.scss";
import commonservice from "@apis/commonservice";
import { handleGlobalRecaptchaSuccess } from "@apis/hooks";
import CommonButton from "@components/CommonButton";
import Mask from "@components/Mask";
import { Turnstile } from "@marsidev/react-turnstile";
import report from "@report";
import message from "@utils/message";
import PubSub from "pubsub-js";
import { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

export default () => {
  useTranslation();
  const [visible, setVisible] = useState(false);
  const refCaptcha = useRef<any>(null);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    PubSub.subscribe("GlobalRecaptcha", (_msg, data) => {
      if (data && data.visible !== undefined) {
        if (data.visible !== visible) {
          setVisible(data.visible);
        }
      }
    });
  }, []);

  const handleCallbackSuccess = () => {
    const pageList = ["/insight", "/script-rewrite", "/script-review"];
    if (pageList.includes(location.pathname)) {
      handleGlobalRecaptchaSuccess();
    } else {
      window.location.reload();
    }
  };

  const handleCallback = async (captcha: string) => {
    try {
      const res = await commonservice.checkGoogleGrecaptcha<string>({
        captcha,
        captchaType: "cloudflare",
      });
      if (res === "succeed") {
        setVisible(false);
        handleCallbackSuccess();
      } else {
        message.warning("Verification failed, please try agin");
        report.error("grecaptcha verify failed");
        refCaptcha.current?.reset();
      }
    } catch (err) {
      message.warning("Verification failed, please try agin");
      setVisible(false);
      refCaptcha.current?.reset();
    }
  };

  return (
    <Mask visible={visible} className="Layout-GlobalRecaptcha-Mask">
      <div className="Layout-GlobalRecaptcha flex flex-col items-center gap-[30px]">
        <Turnstile
          ref={refCaptcha}
          siteKey="0x4AAAAAAAQflMFWQZ7Jj7na"
          onSuccess={(token) => {
            setToken(token);
          }}
        />
        <CommonButton
          type="primary"
          disabled={!token}
          onClick={() => handleCallback(token as string)}
          className="w-[110px] h-[36px] text-[16px]"
        >
          <Trans>Submit</Trans>
        </CommonButton>
        <IconClose
          className="icon-close"
          onClick={() => {
            setVisible(false);
          }}
        ></IconClose>
      </div>
    </Mask>
  );
};
